import { AloBase } from '@/models/alo/AloBase';
import { StateItem, buildStateItem } from '@/models/alo/StateItem';
import { AloStatutCompactGroup } from '@/models/alo/AloStatutCompactGroup';
import { AloFamille } from '@/models/alo/AloFamille';
import { AloRubrique } from '@/models/alo/AloRubrique';
import { AloUniver } from '@/models/alo/AloUniver';
import { AloEnseigne } from '@/models/alo/AloEnseigne';
import { AloMeta } from '@/models/alo/AloMeta';
import { AloFluxBuilder } from '@/models/alo/AloFluxBuilder';
import { AloMetaGroup } from '@/models/alo/AloMetaGroup';
import { AloMarque } from '@/models/alo/AloMarque';

export interface ICatalogueState { 
  marqueStatus: string;

  marques: {[id:number]:AloMarque}
  marquesList: StateItem<number[]>

  referenceStatus: string  
  
  dispos: {[id:number]:AloBase}
  disposList:StateItem<number[]>

  enseignes: {[id:number]:AloEnseigne}
  enseignesList:StateItem<number[]>

  transporters:{[id:number]:AloBase}
  transportersList:StateItem<number[]>

  tarifModels:{[id:number]:AloBase}
  tarifModelsList:StateItem<number[]>

  statutCompactGroups:{[id:number]:AloStatutCompactGroup}
  statutCompactGroupsList:StateItem<number[]>

  fluxBuildersStatus: string
  fluxBuilders:{[id:number]:AloFluxBuilder}
  fluxBuildersList:StateItem<number[]>  
  
  fluxRestrictedFlag:Array<string>  

  metasStatus: string
  metas: {[id:number]:AloMeta}  
  metasList: StateItem<number[]>

  metaGroups: {[id:number]:AloMetaGroup}  
  metaGroupsList: StateItem<number[]>

  partRestrictedFlag:Array<string>  
    
  univers:{[id:number]:AloUniver}
  universList:StateItem<number[]>

  rubriques:{[id:number]:AloRubrique}
  rubriquesList:StateItem<number[]>

  familles:{[id:number]:AloFamille}
  famillesList:StateItem<number[]>

  categoriesStatus: string  

}

//Initial State
const state: ICatalogueState = {   
  marqueStatus: '',
  marques:{} as {[id:number]:AloMarque},
  marquesList: buildStateItem([] as number[],-5), //on perime le state item initial pour savoir que la reponse est vide
  referenceStatus:'',
  dispos:{} as {[id:number]:AloBase},
  disposList: buildStateItem([] as number[],-5),
  enseignes:{} as {[id:number]:AloEnseigne},
  enseignesList: buildStateItem([] as number[],-5),
  transporters:{} as {[id:number]:AloBase},
  transportersList: buildStateItem([] as number[],-5),
  tarifModels:{} as {[id:number]:AloBase},
  tarifModelsList: buildStateItem([] as number[],-5),
  statutCompactGroups:{} as {[id:number]:AloStatutCompactGroup},
  statutCompactGroupsList: buildStateItem([] as number[],-5), 
  fluxBuildersStatus:'',
  fluxBuilders:{} as {[id:number]:AloFluxBuilder},
  fluxBuildersList: buildStateItem([] as number[],-5),   
  fluxRestrictedFlag:[] as Array<string>,
  metasStatus: '',
  metas:{} as {[id:number]:AloMeta},
  metasList: buildStateItem([] as number[],-5),    
  metaGroups:{} as {[id:number]:AloMetaGroup},
  metaGroupsList: buildStateItem([] as number[],-5),    
  partRestrictedFlag:[] as Array<string>,
  categoriesStatus:'',
  univers:{} as {[id:number]:AloUniver},
  universList: buildStateItem([] as number[],-5),
  rubriques:{} as {[id:number]:AloRubrique},
  rubriquesList: buildStateItem([] as number[],-5),
  familles:{} as {[id:number]:AloFamille},
  famillesList: buildStateItem([] as number[],-5),  

}

export default state